import * as t from "io-ts";
import { Category } from "./Category";
import { Metadata } from "./Metadata";
import { Quiz } from "./Quiz";
import { Result } from "./Result";

export const Training = t.intersection([
  t.type({
    categories: t.array(Category),
  }),
  t.partial({
    id: t.string,
    cid: t.string,
    eid: t.string,
    bid: t.string,
    aid: t.string,
    oid: t.string,
    quizzes: t.array(Quiz),
    result: Result,
    metadata: Metadata,
  }),
]);

export interface Training {
  id?: string;
  cid?: string;
  eid?: string;
  bid?: string;
  aid?: string;
  oid?: string;
  categories: Array<Category>;
  quizzes?: Array<Quiz>;
  result?: Result;
  metadata?: Metadata;
}
